/**
 * User Profile Utilities
 * Helper functions for managing user profile updates
 */

import { UserProfile, userService } from "../services/userService";

/**
 * Update and store user profile with new permissions
 * @param currentUser - The current user profile
 * @param permissions - The permissions to add to the profile
 */
export function updateUserProfileWithPermissions(currentUser: UserProfile, permissions: string[]): void {
  const updatedUser = { ...currentUser, permissions };
  userService.storeProfile(updatedUser);
}
